import React, { Suspense, lazy, ComponentType } from 'react';
import { Route, Routes } from 'react-router-dom';

/**
 * File-based routing powered by Vite's import.meta.glob.
 *
 * Drop a file in src/pages/ and it becomes a route automatically:
 *
 *   index.tsx             →  /
 *   about.tsx             →  /about
 *   email-verify/$id.tsx  →  /email-verify/:id
 *   $.tsx                 →  /* (catch-all)
 */

const pageModules = import.meta.glob<{ default: ComponentType }>('./pages/**/[a-z$]*.tsx');

function toRoutePath(filePath: string): string {
  let path = filePath
    .replace('./pages/', '')
    .replace(/\.tsx$/, '')
    .replace(/(^|\/)index$/, '');

  path = path.replace(/\$([^/$]+)/g, ':$1');
  path = path.replace(/\$$/, '*');

  return `/${path}`;
}

const routes = Object.entries(pageModules).map(([filePath, importFn]) => ({
  path: toRoutePath(filePath),
  Component: lazy(importFn),
}));

export default function AppRoutes() {
  return (
    <Suspense fallback={null}>
      <Routes>
        {routes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
      </Routes>
    </Suspense>
  );
}
